import { ColDef } from 'ag-grid-community';
import get from 'lodash/get';
import { columns } from 'erisxkit/client';
import { formatTimeLocal, formatDateLocal } from '../../../../utils/time';
import FutureTrade from '../../../../ts/models/FutureTrade.model';
import Big from 'bignumber.js';

const columnDefs: ColDef<FutureTrade>[] = [
  {
    headerName: 'Trade Date',
    field: 'date',
    valueFormatter: ({ data }: { data?: FutureTrade }) =>
      data?.reportDate
        ? formatDateLocal(get(data, 'reportDate', ''))
        : formatDateLocal(get(data, 'date', '')),
    initialWidth: 200,
  },
  {
    headerName: 'Exchange',
    field: 'exchangeMicCode',
    sortable: false,
    initialWidth: 200,
  },
  {
    headerName: 'Product',
    field: 'productSymbol',
    filter: 'agTextColumnFilter',
    initialWidth: 200,
  },
  {
    headerName: 'Contract',
    field: 'clearingSymbol',
    sortable: false,
    initialWidth: 200,
  },
  {
    headerName: 'Member Name',
    field: 'memberName',
    sortable: false,
    initialWidth: 200,
  },
  {
    headerName: 'Account',
    field: 'accountLabel',
    initialWidth: columns.ACCOUNT_NAME,
    sortable: false,
  },
  {
    headerName: 'Trade Type',
    valueFormatter: ({ data }: { data?: FutureTrade }) =>
      data?.tradeType || data?.trdType || '',
    field: 'tradeType',
    sortable: false,
    initialWidth: 150,
  },
  {
    headerName: 'Quantity',
    field: 'qty',
    sortable: false,
    initialWidth: 150,
  },
  {
    headerName: 'Price',
    field: 'px',
    initialWidth: 150,
  },
  {
    headerName: 'Reserved Margin',
    valueFormatter: ({ data }: { data?: FutureTrade }) =>
      data?.initialMargin || '',
    field: 'initialMargin',
    sortable: false,
    initialWidth: 200,
  },
  {
    headerName: 'Execution Time',
    field: 'execTime',
    initialWidth: 205,
    valueFormatter: ({ data }: { data?: FutureTrade }) =>
      formatTimeLocal(data?.time),
    sortable: false,
  },
  {
    headerName: 'Report Time',
    field: 'reportTime',
    initialWidth: 205,
    valueFormatter: ({ data }: { data?: FutureTrade }) =>
      formatTimeLocal(data?.reportTime),
    sortable: false,
  },
  {
    headerName: 'Aggressor',
    field: 'aggressor',
    initialWidth: 150,
  },
  {
    headerName: 'Exchange Fee',
    field: 'exchange',
    valueFormatter: ({ data }: { data?: FutureTrade }) =>
      `${data?.exchangeFee || data?.exchangeFees || ''} ${data?.feeType || ''}`,
    sortable: false,
    initialWidth: 150,
  },
  {
    headerName: 'Clearing Fee',
    field: 'clearingFee',
    valueFormatter: ({ data }: { data?: FutureTrade }) => {
      const feeClearing = data?.clearingFee || data?.clearingFees || 0;
      const feeClearingTotal = new Big(feeClearing)
        .plus(data?.deliveryFee || 0)
        .toFixed();
      return `${feeClearingTotal} ${data?.feeType || ''}`;
    },
    sortable: false,
    initialWidth: 150,
  },
  {
    headerName: 'Spread ID',
    field: 'secondaryExecId',
    sortable: false,
    initialWidth: 120,
  },
  {
    headerName: 'Submitter',
    field: 'submitter',
    sortable: false,
    initialWidth: 120,
  },
  {
    headerName: 'Trade Id',
    field: 'tradeId',
    initialWidth: 120,
    sortable: false,
  },
  {
    headerName: 'CAR',
    field: 'customerAccountRef',
    sortable: false,
    initialWidth: 120,
  },
  {
    headerName: 'CTI',
    field: 'cti',
    sortable: false,
    initialWidth: 120,
  },
  {
    headerName: 'Origin',
    field: 'origin',
    sortable: false,
    initialWidth: 120,
  },
];

export default columnDefs;
